<template>
  <div class="pt-8 gmap_canvas">
    <iframe
      id="gmap_canvas"
      :src="srcMap"
      width="100%"
      height="400px"
      frameborder="0"
      style="border:0;"
    />
  </div>
</template>

<script>
export default {
  name: "GoogleMaps",
  props: {
    srcMap: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.gmap_canvas {
  overflow: hidden;
  background: none !important;
  height: 100%;
  width: 100%;
}
</style>
